<template>
  <div>
    <!-- <div class="case-tabs">
      <div class="case-tab case-tab-predmet">Osobno</div>
      <div class="case-tab case-tab-sudionici">Predmeti</div>
      <div class="case-tab case-tab-spisi">Ured</div>
      <div class="case-tab case-tab-pošta active">Organizacija</div>
      <div class="case-tab case-tab-financije">Putni Nalog</div>
    </div> -->
    <ProjTab :current_tab="'Kalendar'" :project_info="project_info"/>
    <div v-if="permission.create" class="upload-dokumenta-button kalendar-novi-button" @click="goToForm()">
      Kreiraj novi događaj
      <div class="upload-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <CalendarComponent />
    <!-- <calendar-create-edit
      :accessToken="accessToken"
      :spisList="rootSpisi"
      :caseId="predmet_info.broj_predmeta"
    ></calendar-create-edit> -->
  </div>
</template>

<script>
import auth from "@/services/auth";
import person from "@/apiCallers/person";
import CalendarComponent from "@/components/calendarComponents/CalendarComponent.vue";
// import CalendarCreateEdit from "@/components/caseComponents/CalendarCreateEdit.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import {getProjData} from "@/router/project/handler"

export default {
  components: { CaseTab, CalendarComponent, ProjTab},
  data: function () {
    return {
      //CURRENT CASE DATA BEGIN
      project_info: {broj_projekta:""},
      accessToken: "",
      permission : {
        create : true,
        update : true,
        delete : true,
        read : true
      }
      // categories: [
      //   { name: "Važno", class: "d-red" },
      //   { name: "Osobno", class: "d-grey" },
      //   { name: "Predmet", class: "d-green" },
      //   { name: "PSOD", class: "d-red" },
      // ],
    };
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
     await getProjData(this.$route.params.uid).then(async (response) => {

      this.project_info = response;
    })
  },
  methods: {
    goToForm(){
      this.$router.push("kalendar/novi-dogadaj");
    },
  },
  mounted() {
    this.$store.state.paginacija.title = "Upravljanje predmetom";
  },
};
</script>

<style>
</style>